module.exports = __webpack_public_path__ + "static/media/406JamesPBrawleyDrNW_2018-06-12_166.fec49178.jpg";